import { httpsUrl } from 'config/url';

export const signInUrl = `${httpsUrl()}/login-guest`;

export const generatePropertyPreviewLink = (pid: number) => `${httpsUrl()}/${pid}`;

export const iosAppUrl = 'https://apps.apple.com/us/app/alluradirect-vacation-rentals/id1588310138';
export const androidAppUrl = 'https://play.google.com/store/apps/details?id=com.alluraDirect';
